
import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'

import {
  isUserLoggedIn,
  getUserRole,
  getHomeRouteForLoggedInUser
} from '@/auth/utils'

import apps from './routes/apps'
import dashboard from './routes/dashboard'
import pages from './routes/pages'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,

  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },

  routes: [
    {
      path: '/',
      redirect: {
        name: 'dashboard-ecommerce'
      }
    },

    ...apps,
    ...dashboard,
    ...pages,

    {
      path: '*',
      redirect: '/error-404'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    if (!isLoggedIn) {
      return next({
        name: 'auth-login'
      })
    }

    return next({
      name: 'misc-not-authorized'
    })
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userRole = getUserRole()

    const homeRoute = getHomeRouteForLoggedInUser(userRole)

    if (!homeRoute) {
      return next({
        name: 'misc-not-authorized'
      })
    }

    if (to.path === homeRoute) {
      return next()
    }

    return next(homeRoute)
  }

  return next()
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')

  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
